// extracted by mini-css-extract-plugin
export default {"breadcrumb":"style_breadcrumb__UzpTv","title":"style_title__uXkVK","arrow":"style_arrow__v2qG8"};